import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    // Always white regardless of app theme — this tints content sitting on top of
    // Backdrop's own dark scrim, not a themed surface.
    color: theme.custom.toolbarAccentContrast,
  },
  loader: {
    top: 30,
    left: 0,
    right: 0,
    width: '100%',
    height: 'calc(100% - 50px)',
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9000
  },
  progressBar: {
    left: 0,
    right: 0,
    width: '30%',
    height: '5vh',
    margin: '0 auto',
    textAlign: 'center',
    position: 'absolute',
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.toolbarBackground : theme.palette.background.paper,
    padding: 15
  },
  message: {
    // theme.custom.toolbarText is 0.87-alpha black in light mode, not pure black —
    // branch so light mode stays byte-identical to the original literal. Uses the
    // dedicated chrome token, not theme.palette.text.primary, since that palette key
    // is frozen to always-light for the sake of unmigrated screens (see theme.js).
    color: theme.palette.type === 'dark' ? theme.custom.toolbarText : '#000',
    textAlign: 'center',
    width: '100%'
  }
}));


export const Loader = ({
  isOpen = true,
  color = "inherit",
  size = 80,
  thickness = 3.6,
  variant = 'indeterminate',
  showBackdrop = true,
  zIndex = 2300,
  progress = null,
  message = null,
  ...props
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const progressTrackStyle = { backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)' };

  if (props.isDownloadProgress && props.isDownloadProgress === true) {
    return (<Backdrop className={classes.backdrop} open={isOpen} style={{ zIndex: zIndex }}>
      <Box className={classes.progressBar}>
        {message && <Box
          display="flex"
          alignItems="center">
          <Typography className={classes.message}>{message}</Typography>
        </Box>}
        <Box display="flex"
          alignItems="center">
          <Box width="100%" mr={1} style={progressTrackStyle}>
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
              <LinearProgress />
            </Stack>
          </Box>
        </Box>
      </Box>
    </Backdrop>)
  }
  if (progress) {
    return (
      <Backdrop className={classes.backdrop} open={isOpen} style={{ zIndex: zIndex }}>
        <Box className={classes.progressBar}>
          {message && <Box
            display="flex"
            alignItems="center">
            <Typography className={classes.message}>{message}</Typography>
          </Box>}
          <Box display="flex"
            alignItems="center">
            <Box width="100%" mr={1} style={progressTrackStyle}>
              <LinearProgress variant="determinate" {...props} style={{ width: `${progress}%` }} />
            </Box>
            <Box minWidth={35}>
              <Typography variant="body2" color="textPrimary">{`${Math.round(
                progress,
              )}%`}</Typography>
            </Box>
          </Box>
        </Box>
      </Backdrop>
    )
  }
  return (
    <>
      {
        props.contained ?
          <div style={{ width: '100%', minHeight: props?.containerSize ?? size, display: 'flex', justifyContent: 'center', zIndex: zIndex, alignItems: 'center' }}>
            <CircularProgress
              style={{ textAlign: 'center', margin: '0 auto', alignSelf: 'center' }}
              color="inherit"
              size={size ?? 40}
              thickness={3.6}
              variant="indeterminate"
            />
          </div>
          :
          <div>
            {
              showBackdrop ? (<Backdrop className={classes.backdrop} open={isOpen} style={{ zIndex: zIndex }}>
                <CircularProgress
                  style={{ position: 'absolute', right: 0, left: 0, textAlign: 'center', margin: '0 auto' }}
                  color={color}
                  size={size}
                  thickness={thickness}
                  variant={variant}
                />
              </Backdrop>)
                :
                (<Box className={classes.loader} style={{ display: isOpen ? 'flex' : 'none' }}>
                  <CircularProgress
                    color={color}
                    size={size}
                    thickness={thickness}
                    variant={variant}
                  />
                </Box>)
            }
          </div>

      }
    </>
  );
}
